import React from "react";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import BtnRounded from "./sub-comps/BtnRounded";
import OpenCalendly from "./sub-comps/OpenCalendly";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import land1 from '../assets/landing/land1.png';
// import land2 from '../assets/landing/land2.png';
import land2 from '../assets/landing/landingDesign2.png';
import land3 from '../assets/landing/land3.png';
import land4 from '../assets/landing/land4.png';
const bgImgs = [land1, land2, land3]; 
function Landing({
  backgroundImage,
  height,
  title,
  description,
  buttonText,
  onButtonClick,
  overlayColors = { from: "white/60", to: "white/30" },
}) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
  };



  const easing = [0.6, -0.05, 0.01, 0.99]; // Custom cubic-bezier easing

  const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 1, delay: i * 0.3, ease: easing },
    }),
  };

  

  return (
    <div
      className={`relative ${height} w-full bg-cover bg-center`}
      // style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Slider {...settings}>
        {bgImgs.map((item, index) => (
          <div key={index} className=" outline-none h-fit w-fit">
            <img
              src={item}
              // className=" lg:h-[150px] lg:w-[150px]"
              className={`relative ${height} w-full object-cover bg-center`}
              alt={`Slide ${index}`}
            />
          </div>
        ))}
      </Slider>
      {/* Background Overlay */}
      <motion.div
        className={`absolute z-10 inset-0 bg-gradient-to-t from-${overlayColors.from} to-${overlayColors.to} z-10`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      ></motion.div>

      {/* Content container */}
      <div className="relative z-20 flex items-center w-full h-full -translate-y-full ">
        <motion.div
          className="lg:ml-14 lg:px-8 lg:max-w-[500px]  ml-4 py-4 pl-4 pr-8 max-w-[320px] text-customAqua600 bg-white/20 lg:bg-none"
          initial="hidden"
          animate="visible"
          variants={textVariants}
          custom={0}
        >
          <motion.p
            className="lg:text-6xl 2xl:text-7xl lg:mb-4 text-4xl mb-4 font-semibold"
            variants={textVariants}
            custom={0}
          >
            {title}
          </motion.p>
          <motion.p
            className="lg:text-lg text-[16px] p-2 lg:p-0 mb-4 font-medium "
            variants={textVariants}
            custom={1}
          >
            {description}
          </motion.p>
          {buttonText && (
            <motion.div
              variants={textVariants}
              custom={2}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <BtnRounded onClick={onButtonClick}>
                <OpenCalendly />
              </BtnRounded>
            </motion.div>
          )}
        </motion.div>
      </div>
    </div>
  );
}

export default Landing;

// import React from "react";
// import { motion } from "framer-motion";
// import imglanding02 from "../assets/landing02.webp";
// import BtnRounded from "./sub-comps/BtnRounded";

// function Landing() {
//   const easing = [0.6, -0.05, 0.01, 0.99]; // Custom cubic-bezier easing

//   const textVariants = {
//     hidden: { opacity: 0, y: 30 },
//     visible: (i) => ({
//       opacity: 1,
//       y: 0,
//       transition: { duration: 1, delay: i * 0.3, ease: easing },
//     }),
//   };

//   return (
//     <div
//       className="relative h-screen w-full bg-cover bg-center"
//       style={{ backgroundImage: `url(${imglanding02})` }}
//     >
//       {/* Background Overlay */}
//       <motion.div
//         className="absolute inset-0 bg-gradient-to-t from-white/60 to-white/30 z-10"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 1 }}
//       ></motion.div>

//       {/* Content container */}
//       <div className="relative z-20 flex items-center w-full h-full">
//         <motion.div
//           className="lg:ml-14 lg:px-8 lg:max-w-[500px] px-8 max-w-[320px] text-customAqua600"
//           initial="hidden"
//           animate="visible"
//           variants={textVariants}
//           custom={0}
//         >
//           <motion.p
//             className="lg:text-5xl lg:mb-4 text-3xl mb-4 font-semibold"
//             variants={textVariants}
//             custom={0}
//           >
//             Gardez Votre Sourire Propre Et Brillant
//           </motion.p>
//           <motion.p
//             className="lg:text-lg text-sm mb-4 leading-6"
//             variants={textVariants}
//             custom={1}
//           >
//             Nous fournissons des services de soins dentaires complets pour toute
//             la famille. Notre équipe expérimentée utilise les technologies les
//             plus récentes pour fournir des soins de haute qualité.
//           </motion.p>
//           <motion.div
//             variants={textVariants}
//             custom={2}
//             whileHover={{ scale: 1.1 }}
//             whileTap={{ scale: 0.9 }}
//           >
//             <BtnRounded>En Savoir Plus</BtnRounded>
//           </motion.div>
//         </motion.div>
//       </div>
//     </div>
//   );
// }

// export default Landing;
